import { render, staticRenderFns } from "./PartnerTermsIndia.vue?vue&type=template&id=4b0d576d&scoped=true"
import script from "./PartnerTermsIndia.vue?vue&type=script&lang=js"
export * from "./PartnerTermsIndia.vue?vue&type=script&lang=js"
import style0 from "./PartnerTermsIndia.vue?vue&type=style&index=0&id=4b0d576d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d576d",
  null
  
)

export default component.exports